import style from './style.scss';
import translations from './translations';
import Row from './common/Table/Row';
import Table from './common/Table';
import React, { memo } from 'react';
import Cell from './Cell';
import { useDynamicReducerSelector } from './state';
import { T } from 'ramda';
import useTranslate from './hooks/useTranslate';
import DateView from './components/DateView';
import classNames from './common/classNames';

const WinnersTable = () => {
    const status = useDynamicReducerSelector(state => state.status);
    const isParcelCompleted = status === 'COMPLETED';
    const lastWinners = useDynamicReducerSelector(state => state.lastWinners);
    const isNicknameNeeded = useDynamicReducerSelector(state => state.join.nicknameNeeded);
    const t = useTranslate();
    const defineName = (name, nickname) => {
        return isNicknameNeeded ? nickname : nickname;
    };
    return <Table>
        <div className={style.panelRow}>
            <Cell textClass={classNames(style.panelCellHeaderText, style.prizesHeaderTitle)}
                  additionalClass={style.prizesCell}>
                {t(translations.headerLastWinnersNickname)}</Cell>
            <Cell textClass={classNames(style.panelCellHeaderText,
                { [style.prizesRemainHeaderTitle] : isParcelCompleted })}
                  additionalClass={classNames({ [style.prizesRemainCell] : isParcelCompleted })}>
                {t(translations.headerLastWinnersPrize)}</Cell>
            {!isParcelCompleted &&
            <Cell textClass={classNames(style.panelCellHeaderText, style.prizesRemainHeaderTitle)}
                  additionalClass={style.prizesRemainCell}>{t(translations.headerLastWinnersTime)}</Cell>}
        </div>
        {lastWinners.map(({ nickname, name, prizeDisplayName, timeAwarded, finalPrize, isCurrentUser }) => {
            return <Row key={`${nickname}@@${prizeDisplayName}@@${timeAwarded}`}
                 className={classNames({ [style.currentUserRow]: isCurrentUser })}
                 classNameOuter={classNames({ [style.currentUserOuterRow]: isCurrentUser })}>
                <div className={style.panelContentRow}>
                    <Cell textClass={classNames(style.panelCellText, style.panelCellTextFlex)}
                          additionalClass={style.cellStart}
                          isFinalPrize={classNames({ [style.isCurrentUserText]: isCurrentUser })}>
                        {defineName(name, nickname)}</Cell>
                    <Cell textClass={classNames(style.panelCellText,
                        { [style.completedPrizesRemainCellText] : isParcelCompleted })}
                          isFinalPrize={classNames({ [style.isCurrentUserText]: isCurrentUser })}
                          additionalClass={classNames({ [style.prizesRemainCell] : isParcelCompleted })}>
                        {finalPrize && <div className={ classNames(style.finalPrizeImg, style.iconClassCell)}/>}
                        {prizeDisplayName}
                    </Cell>
                    {!isParcelCompleted && <Cell textClass={classNames(style.panelCellText, style.prizesRemainCellText)}
                                                 additionalClass={style.prizesRemainCell}>
                        <DateView timeStamp={timeAwarded} format={'hh:mm:ss'} utc={false}
                                  isFinalPrize={classNames({ [style.isCurrentUserTextTime]: isCurrentUser })}/>
                    </Cell>}
                </div>
                <div className={classNames(style.horizontalLine, { [style.hide]: isCurrentUser && !isParcelCompleted })}/>
            </Row>;
            }
        )}
    </Table>;
};

export default memo(WinnersTable, T);
